import { orderBy } from 'lodash'
import utils from '@/helpers/utils'

export default function(_this) {
  return {
    async create(data, callback) {
      const { title, dash, template = null, sync } = data

      const order = await new Promise(resolve => {
        if (!template) {
          _this.getRef('tabs').once('value', snapshot => {
            resolve(utils.count(snapshot.val() || {}))
          })
        } else {
          _this.root
            .ref('dashboards')
            .child(template)
            .child('tabs')
            .once('value', snapshot => {
              resolve(utils.count(snapshot.val() || {}))
            })
        }
      })

      const newTab = {
        title,
        template,
        order,
      }

      if (dash) {
        const key = _this.root
          .ref('dashboards')
          .child(dash)
          .child('tabs')
          .push(newTab, () => {
            if (callback) callback(key)
          }).key
      } else {
        const key = _this.getRef('tabs').push(newTab, () => {
          if (!sync) utils.corePagesGridSync.tabAdded(title, key)

          if (callback) callback(key)
        }).key
      }
    },
    read(cb, once) {
      _this.getRef('tabs')[once ? 'once' : 'on']('value', snapshot => {
        cb(snapshot.val() || {})
      })
    },
    renameTab(title, tabKey) {
      return new Promise(resolve => {
        _this
          .getRef('tabs')
          .child(tabKey)
          .child('title')
          .set(title, () => {
            utils.corePagesGridSync.tabRenamed(title, tabKey)

            resolve()
          })
      })
    },
    renameSubTab(title, tabKey, subTabKey) {
      return new Promise(resolve => {
        _this
          .getRef('subTabs')
          .child(tabKey)
          .child(subTabKey)
          .child('title')
          .set(title, () => resolve())
      })
    },
    async delete(key, cb) {
      await new Promise(function(resolve) {
        _this
          .getRef('tabs')
          .child(key)
          .remove(err => {
            if (err) {
              if (cb) cb(err)
            }

            utils.corePagesGridSync.tabRemoved(key)

            resolve()
          })
      })

      await new Promise(function(resolve) {
        _this
          .getRef('widgets')
          .orderByChild('tab')
          .equalTo(key)
          .on('value', snapshot => {
            let data = snapshot.val() || {}

            for (let widgetKey in data) {
              _this.widgets.delete(widgetKey, data[widgetKey]['dependency'])
            }

            resolve()
          })
      })

      _this
        .getRef('tabs')
        .orderByChild('order')
        .once('value', snapshot => {
          const newOrderedTabs = {}
          let count = 0

          snapshot.forEach(child => {
            const tab = child.val()
            tab.order = count++
            newOrderedTabs[child.key] = tab
          })

          _this.getRef('tabs').set(newOrderedTabs, err => {
            if (!cb) return

            if (err) cb(err)
            else cb()
          })
        })
    },
    deleteSubTab(tabKey, subTabKey) {
      return new Promise(resolve => {
        _this
          .getRef('subTabs')
          .child(tabKey)
          .child(subTabKey)
          .remove(() => resolve())
      })
    },
    setTabOnLoad(tab) {
      _this.getRef('tabOnLoad').set(tab)
    },
    setPrivateTab(tabs) {
      _this.getRef('privateTabs').set(tabs)
    },
    readSubTabs(cb, once) {
      _this.getRef('subTabs')[once ? 'once' : 'on']('value', snapshot => {
        const dbSubTabs = snapshot.val()

        if (dbSubTabs) {
          const subTabs = {}

          for (let tabKey in dbSubTabs) {
            for (let subTabKey in dbSubTabs[tabKey]) {
              dbSubTabs[tabKey][subTabKey].key = subTabKey
            }
            const tmpSubTabs = orderBy(dbSubTabs[tabKey], 'order')
            for (let subTab of tmpSubTabs) {
              if (!subTabs[tabKey]) subTabs[tabKey] = {}
              subTabs[tabKey][subTab.key] = subTab
              delete subTabs[tabKey][subTab.key].key
            }
          }

          cb(subTabs)
        } else {
          cb(null)
        }
      })
    },
    createSubTab(tabKey, data, cb) {
      const key = _this
        .getRef('subTabs')
        .child(tabKey)
        .push(data, () => {
          if (cb) cb(key)
        }).key
    },
    /**
     * Set default sub tab for current tab
     * @param {String} tab - current tab id
     * @param {String} subTab - current sub tab id
     */
    toggleDefaultSubTab(tab, subTab) {
      _this
        .getRef('tabs')
        .child(tab)
        .child('defaultSubTab')
        .set(subTab)
    },
    /**
     * Toggle tab expanded state
     * @param {String} tab - current tab id
     */
    toggleExpandedByDefault(tab, state) {
      _this
        .getRef('tabs')
        .child(tab)
        .child('expandedByDefault')
        .set(!state)
    },
    /**
     * Remove subtabs and widgets of subtabs
     * @param {String} tab - current tab key
     * @param {Function} cb - callback function
     */
    async removeSubTabs(tab, cb) {
      const subTabs = await new Promise(resolve => {
        _this
          .getRef('subTabs')
          .child(tab)
          .once('value', snapshot => {
            resolve(Object.keys(snapshot.val()))
          })
      })

      cb()

      _this
        .getRef('subTabs')
        .child(tab)
        .remove()

      for (let subTab of subTabs) {
        _this
          .getRef('widgets')
          .orderByChild('subtab')
          .equalTo(subTab)
          .once('value', snapshot => {
            const widgets = snapshot.val() ? Object.keys(snapshot.val()) : null

            if (!widgets) return

            for (let widget of widgets) {
              _this
                .getRef('widgets')
                .child(widget)
                .remove()
            }
          })
      }
    },
    saveTabs(tabs) {
      _this.getRef('tabs').set(tabs)
    },
    saveSubTabs(tab, subTabs) {
      _this
        .getRef('subTabs')
        .child(tab)
        .set(subTabs)
    },
    async changeParentTab(tab, subtab, newParent, cb) {
      const subTabContent = await new Promise(resolve => {
        _this
          .getRef('subTabs')
          .child(tab)
          .child(subtab)
          .once('value', snapshot => {
            resolve(snapshot.val())
          })
      })

      const newParentSubTabContent = await new Promise(resolve => {
        _this
          .getRef('subTabs')
          .child(newParent)
          .once('value', snapshot => {
            resolve(snapshot.val())
          })
      })

      let subTabs = {}

      if (newParentSubTabContent) {
        const count = Object.keys(newParentSubTabContent).length
        subTabContent.order = count
        newParentSubTabContent[subtab] = subTabContent
        subTabs = newParentSubTabContent
      } else {
        subTabContent.order = 0
        subTabs[subtab] = subTabContent
      }

      await new Promise(resolve => {
        _this
          .getRef('subTabs')
          .child(tab)
          .child(subtab)
          .remove(() => {
            resolve()
          })
      })

      _this
        .getRef('subTabs')
        .child(newParent)
        .set(subTabs, () => {
          cb()
        })
    },
    /**
     * Set icon for current tab
     * @param {String} data.tab - current tab
     * @param {String} data.name - icon name
     * @param {String} data.color - icon color
     */
    setIcon({ tab, name, color }) {
      return new Promise(resolve => {
        _this
          .getRef('tabs')
          .child(tab)
          .child('icon')
          .set({ name, color }, () => {
            resolve()
          })
      })
    },
  }
}
